import React from "react"; 

// core components
import GridItem from "../../views/Grid/GridItem.js";
import GridContainer from "../../views/Grid/GridContainer.js";
import Table from "../../views/Table/Table.js";
import Card from "../../views/Card/Card.js";
import CardHeader from "../../views/Card/CardHeader.js";
import CardBody from "../../views/Card/CardBody.js";

import axios from 'axios'
import style from './styles.module.css'
import Button from '@material-ui/core/Button'
import ConfCoupon from './confCoupon/confCoupon'
import IconButton from '@material-ui/core/IconButton'
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import Snackbar from '../utils/snackbar/Snackbar'
import {withRouter} from 'react-router-dom' 
import CircularProgress from '@material-ui/core/CircularProgress'
import {connect} from 'react-redux'
import {getAllCoupons} from '../../containers/app/actions' 
import TopBar from "../utils/Topbar/TopBar.js";
import ConfirmAlert from "../utils/ConfirmAlert/ConfirmAlert.js";
import moment from "moment";
import CouponDetail from "./couponDetails/CouponDetail";
import Tooltip from "@material-ui/core/Tooltip";
import InputRoundedIcon from "@material-ui/icons/InputRounded";
const Coupons = (props) => { 
  const [data,setData] = React.useState(false)
  const [filteredData,setFilteredData] = React.useState(false)
  const [searchValue,setSearchValue] = React.useState("")
  const [detailModal, setDetailModal] = React.useState(false);
  const [alert,setAlert] = React.useState(false);
  const [addModal,setAddModal] = React.useState(false);
  const [editModal,setEditModal] = React.useState(false);
  const [activeCoupon,setActiveCoupon] = React.useState(false) 

  React.useEffect(() => {
    props.getAllCoupons(props.user._id)
  },[]);


  React.useEffect(() => {
    if(props.coupons) {
      let arr = [];
      arr = props.coupons.filter(val => {
        if(val.couponCode.toLowerCase().includes(searchValue.toLowerCase())) {
          return val;
        }
      }) 
      setFilteredData(arr);
    } else {
      setFilteredData(false)
    }
  },[searchValue,props.coupons]);



  const handleDelete = (value) => {
    axios({
      method: "post",
      url: "/delete-coupon",
      data: {
        id: value._id,
        userId: props.user._id
      }
    }).then(res => {
      setAlert("Deleted Successfully")
      props.getAllCoupons(props.user._id);
    }).catch(err => {
      setAlert("Something went wrong");
    })
  }

  const isLoading = !filteredData;
  const showData = !isLoading;
  const details = [];

  
  !isLoading && filteredData.forEach((val,index) => {
    var sdate = moment(val.startDate).format('DD-mm-yyyy');
    var startDate = sdate;
    var date = moment(val.expiryDate).format('DD-mm-yyyy');
    var expiryDate = date;
    details.push(
      [
        index + 1,
        val.couponCode,
        val.couponType,
        val.discountAmount,
        val.discountPercantage,
        startDate,
        expiryDate,
        val.status, 
        <React.Fragment>  
          {/* <IconButton onClick={() => {
            setActiveCoupon(val)
            setEditModal(true)
          }}>
            <EditRoundedIcon />
          </IconButton> */}
          <Tooltip title="Coupon Details">
            <IconButton
              onClick={() => {
                setDetailModal(true);
                setActiveCoupon(val);
              }}
            >
              <InputRoundedIcon />
            </IconButton>
          </Tooltip>

          <ConfirmAlert msg={`Are you sure you want delete ?`} onClickEvent={() => handleDelete(val)}> 
            <IconButton>
              <DeleteRoundedIcon />
            </IconButton>
          </ConfirmAlert>
        </React.Fragment>
      ]
    )
  });


  return (
    <GridContainer>
      
      {addModal && <ConfCoupon
        type="ADD" 
        open={addModal} 
        onClose={() => setAddModal(false)} 
        onDone={() => {
          setAddModal(false)
          props.getAllCoupons(props.user._id)
        }}
        setAlert={(msg) => setAlert(msg)}
        user={props.user}
      />}
      {activeCoupon && <ConfCoupon 
        type="EDIT"
        coupon={activeCoupon} 
        open={editModal} 
        user={props.user}
        onClose={() => setEditModal(false)} 
        onDone={() => {
          setEditModal(false)
          setActiveCoupon(false)
          props.getAllCoupons(props.user._id)
        }} 
        setAlert={(msg) => setAlert(msg)}
      />}
      {activeCoupon && (
        <CouponDetail
          open={detailModal}
          onClose={() => setDetailModal(false)}
          coupon={activeCoupon}
        />
      )} 
 
      <Snackbar open={alert} handleClose={() => setAlert(false)}/>

      <TopBar
        searchValue={searchValue} 
        onSearchChange={(value) => setSearchValue(value)}  
      />

      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <div className={style.cardHeader}>
              <h4>All Coupons</h4> 

              <div className={style.buttons}> 
                <Button color="secondary" variant="contained" onClick={() => setAddModal(true)}>Add Coupon</Button>
              </div>
            </div>
          </CardHeader>
          <CardBody>
            {isLoading &&
              <div className={style.loader}>
                <CircularProgress />
              </div>
            }
            
            {showData && 
              <Table
                tableHeaderColor="primary" 
                tableHead={["Sl No","Code", "Coupon Type","Discount Amount","Discount %","Start Date","Expiry Date","Status","Action"]}
                tableData={details}
              />}
          </CardBody>
        </Card>
      </GridItem> 
    </GridContainer>
  );
}

const mapStateToProps = state => ({
  user: state.appReducer.user,
  coupons: state.appReducer.coupons
})
export default withRouter(connect(mapStateToProps,{getAllCoupons})(Coupons));